import React from "react";
import { NavLink } from "react-router-dom";

const RetrospectiveValuationTab = () => {
  return (
    <div className="space-y-4 text-gray-800 py-10">
      <h2 className="text-xl font-semibold text-red-600">
       Retrospective Valuation
      </h2>

      <div className="space-y-2">
        <p>
          Retrospective Valuation are commonly required in capital gains
          valuation to work out the back dated property value (eg. 2005) for the
          purpose of working out capital gains tax at the point where the
          property becomes an investment property. Primus Agent Services have over ten (10) years experience in providing
          retrospective valuation to accountants and the Australian Taxation
          Office.
        </p>
      </div>

      <p className="text-blue-600 font-medium">
        Please{" "}
        <NavLink to="/contact-us" className="text-yellow">
          contact us{" "}
        </NavLink>{" "}
        for a guaranteed competitive quote.
      </p>
    </div>
  );
};

export default RetrospectiveValuationTab;
